import { PaginationModelItem } from "app/common/utilities/paging"
import { Link } from "blitz"
import { array } from "fp-ts"
import { pipe } from "fp-ts/function"
import useTranslation from "next-translate/useTranslation"
import { FC } from "react"
import { tw } from "twind"

interface PagingProps {
  getPageUrl: (pageNumber: number) => string
  pagingInfo: PaginationModelItem[]
}

const getPagingLabel = (model: PaginationModelItem) => {
  switch (model.type) {
    case "FIRST_PAGE_LINK":
      return "first"

    case "LAST_PAGE_LINK":
      return "last"

    case "PAGE":
      return model.value.toString()

    case "NEXT_PAGE_LINK":
      return "next"

    case "PREVIOUS_PAGE_LINK":
      return "previous"
  }
}

export const Paging: FC<PagingProps> = ({ getPageUrl, pagingInfo }) => {
  const { t } = useTranslation("paging")

  return (
    <ul className={tw(`flex(& wrap) gap-4 justify-center`, `py-2`, `mt-6`, `select-none`)}>
      {pipe(
        pagingInfo,
        array.map((pageModelItem) => (
          <li key={pageModelItem.key}>
            <Link href={getPageUrl(pageModelItem.value)}>
              <a
                className={tw(
                  `border-1`,
                  `px-2 py-1`,
                  `font-semibold hover:(text-blue-900)`,
                  pageModelItem.isActive &&
                    pageModelItem.type === "PAGE" &&
                    `text-blue-900 border-blue-900`
                )}
              >
                {pipe(pageModelItem, getPagingLabel, t)}
              </a>
            </Link>
          </li>
        ))
      )}
    </ul>
  )
}
